<template>
  <div class="table-container movie-search-result" :style="{
    'min-height': styles.movieListStyles.minHeight,
    'max-height': styles.movieListStyles.maxHeight,
  }">
    <table class="table type-default">
      <thead>
        <tr>
          <th v-if="movieSearch.isQuerying">
            検索中…
          </th>
          <th v-else-if="isMovieSearchResultModeDetail">
            詳細検索結果
          </th>
          <th v-else-if="isMovieSearchResultModeArea">
            範囲検索結果
          </th>
          <th v-else-if="isMovieSearchResultModeRoute">
            ルート検索結果
          </th>
          <th v-else>
            検索結果
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-if="isMovieSearchResultModeNone">
          <tr></tr>
        </template>
        <template v-else-if="movieSearch.isQuerying">
          <tr>
            <td class="ta-center">
              <i class="fa-2x fas fa-spinner fa-spin"></i>
            </td>
          </tr>
        </template>
        <template v-else-if="movieSearch.results.length === 0">
          <tr><td>動画が見つかりませんでした</td></tr>
        </template>
        <template v-else>
          <tr
            v-for="ml in movieSearch.results"
            :key="ml.id"
            :class="{selected: ml.isSelected}"
          >
            <td @click="onMovieSearchResultRowClick(ml)">
              <div class="movie-search-result-row">
                <div class="mr8 info-area">
                  <template v-if="ml.searchType !== 'route'">
                    <span class="ib mr4 ts">
                      {{dtFormat(ml.startTs, 'yyyy/mm/dd HH:MM:SS')}}~
                    </span>
                  </template>
                  <template v-else>
                    <span class="ib mr4 ts">
                      再生時間 {{dtFormat(ml.endTs, 'HH:MM:SS')}}
                    </span>
                  </template>
                  <div class="ib place">
                    <span class="ib mr4 road-name">
                      {{ml.startKp.roadNameDispShort}}
                    </span>
                    <span class="ib mr4 direction">
                      {{ml.startKp.direction}}
                    </span>
                    <span
                      class="ib mr4 place-name"
                      v-if="ml.startKp.placeName !== 'main_line'"
                    >
                      {{ml.startKp.placeName}}
                    </span>
                    <span class="ib kp">
                      <i class="fas fa-location-arrow"></i>
                      {{ml.startKp.kp.toFixed(1)}}
                    </span>
                  </div>
                </div>
                <div class="btn-area">
                  <button
                    class="btn btn-primary btn-xs"
                    @click="onMovieSearchResultPlayClick($event, ml)"
                  >
                    <i class="fas fa-play"></i>
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
  <TabPaneComponent
    :tabs="tabs"
    :default-active-tab="DEFAULT_ACTIVE_TAB"
    :tab-container-min-height="styles.tabStyles.containerMinHeight"
    :tab-container-max-height="styles.tabStyles.containerMaxHeight"
    :tab-content-max-height="styles.tabStyles.contentMaxHeight"
    @click="onTabElementClick"
  />
</template>

<script setup lang="ts">
import TabPaneComponent from 'src/components/Top/TabPaneComponent.vue';
import { dtFormat } from 'src/lib/dateHelper';
import { useMovieSearchStore } from 'src/composables/useMovieSearch';

const DEFAULT_ACTIVE_TAB = 'comment';

const {
  movieSearch,
  styles,
  tabs,
  isMovieSearchResultModeNone,
  isMovieSearchResultModeDetail,
  isMovieSearchResultModeArea,
  isMovieSearchResultModeRoute,
  onMovieSearchResultRowClick,
  onMovieSearchResultPlayClick,
  onTabElementClick,
} = useMovieSearchStore();
</script>

<style lang="scss" scoped>
.movie-search-result {
  overflow: scroll;
  .table.type-default {
    white-space: normal;
  }
  .fa-location-arrow {
    font-size: 0.7rem;
    display: inline-block;
  }
  .movie-search-result-row {
    display: flex;
    justify-content: space-between;
  }
}
</style>
